import React from 'react';

export default function WorkerEventDescription({ ev }) {
  const ti = ev.taskInfo || {};
  if (ev.eventType === 'worker.activity.update') {
    return (
      <span>
        <b>{ev.worker}</b> updated from
        <br />
        <b>{ev.previousActivity || 'Unknown'}
          {ev.previousActivity && ev.timeSpentInPreviousActivity && (
            <span style={{ color: '#888', marginLeft: 8 }}>
              [Duration: {ev.timeSpentInPreviousActivity}]
            </span>
          )}
        </b> to <b>{ev.currentActivity}</b>
      </span>
    );
  }
  if (ti.type === 'voice') {
    return <span>{ti.customer && (<b>{ti.customer}</b>)}</span>;
  }
  if (ti.type === 'meccatask') {
    const customerLine = ti.attributes?.customerId && (
      <span>
        <br />
        <b>{ti.attributes.customerId}</b>
      </span>
    );
    const subject = ti.taskSubject || ti.attributes?.taskSubject;
    const subjectLine = subject && (
      <span>
        <br />
        <span style={{ color: '#374151' }}>{subject}</span>
      </span>
    );
    switch (ev.eventType) {
      case 'task.created':
        return <span>Mecca task created{customerLine}{subjectLine}</span>;
      case 'reservation.created':
        return <span>Mecca task offered{customerLine}{subjectLine}</span>;
      case 'reservation.accepted':
        return <span>Mecca task accepted{customerLine}{subjectLine}</span>;
      case 'reservation.completed':
      case 'task.completed':
        return <span>Mecca task completed{customerLine}{subjectLine}</span>;
      default:
        return <span>{customerLine}{subjectLine}</span>;
    }
  }
  if (ti.type === 'administration') {
    const customerLine = ti.attributes?.customerId && (
      <span>
        <br />
        <b>{ti.attributes.customerId}</b>
      </span>
    );
    if (ev.eventType === 'task.created' || ev.eventType === 'reservation.created') {
      return <span>customerFile opened{customerLine}</span>;
    }
    if (ev.eventType === 'task.completed') {
      return <span>customerFile closed{customerLine}</span>;
    }
  }
  return <span>{ev.description}</span>;
}
